import { lazy } from 'react'

// Keep the lazy import in a small build chunk. Otherwise Vite's dynamic-import
// rewrite creates an additional source map for the entire application bundle.
// This remains lazy: no Rhino/Three code is requested until the preview renders.
export default lazy(() => import('./RhinoModelView.jsx'))
